import React from 'react';
import styled from 'styled-components';
import LoadingSpinner from '../loader';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPaperPlane} from "@fortawesome/pro-solid-svg-icons";
import Hexagon from "../hexagon";

const StyledButton = styled.div`
    width: auto;

    >:first-child {
        cursor: pointer;
    }

    &.loading {
        >:first-child {
            cursor: wait;
        }
    }
`;


export const ButtonContainer = styled.div`
    height: 100%;
    width: 100%;

    max-height: 4rem;
    max-width: 4rem;

`;

export const IconOverlay = styled(FontAwesomeIcon)`
    color: white;
    font-size: 1.625rem;
    filter: drop-shadow(1px 1px 1px #777);
`;

const LoaderContainer = styled.div`
    position: absolute;
    height: auto;
    width: 5rem;
    top: 0px;
    left: -17px;
    right: 0;
    bottom: 0;
`;

export default function SendVox({ onClick, processing, className, common, micPermission, icon, title }) {
    return (
        <StyledButton className={`${className || ''} ${processing ? 'loading' : ''}`}
                      onClick={evt => processing ? false : onClick(evt)}>
            {processing ? <Hexagon common={common}><LoaderContainer><LoadingSpinner size={0.35} /></LoaderContainer></Hexagon> :
                <Hexagon icon={icon ? icon : faPaperPlane} common={common}
                         micPermission={micPermission} title={title} />}
        </StyledButton>
    )
}
